import { render, staticRenderFns } from "./NavigationSidebarAdmin.vue?vue&type=template&id=53778758&scoped=true&"
import script from "./NavigationSidebarAdmin.vue?vue&type=script&lang=js&"
export * from "./NavigationSidebarAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53778758",
  null
  
)

export default component.exports